import { decamelizeKeys } from "humps";

import colors from "theme/colors";
import seedtimeTheme, {
  fontSize,
  fontWeight,
  radius,
  shadows,
  space
} from "theme/seedtime";

const colorsWithSuffix = Object.fromEntries(
  Object.entries(decamelizeKeys(colors, { separator: "-" })).map(([key, value]) => [
    `${key}-color`,
    value
  ])
);

const radiusPixels = Object.fromEntries(
  Object.entries(radius).map(([key, value]) => [`radius-${key}`, `${value}px`])
);
const spacingPixels = Object.fromEntries(
  Object.entries(space).map(([key, value]) => [`space-${key}`, `${value}px`])
);

const shadowsValues = Object.fromEntries(
  Object.entries(shadows).map(([key, value]) => [`shadow-${key}`, value])
);

const fontSizesPixels = Object.fromEntries(
  Object.entries(decamelizeKeys(fontSize, { separator: "-" })).map(([key, value]) => [
    `font-size-${key}`,
    `${value}px`
  ])
);

const fontWeights = Object.fromEntries(
  Object.entries(fontWeight).map(([key, value]) => [`font-weight-${key}`, `${value}`])
);

export const setRootCSSVariables = () => {
  const body = document.querySelector("body");

  Object.entries({
    ...colorsWithSuffix,
    ...seedtimeTheme,
    ...radiusPixels,
    ...spacingPixels,
    ...shadowsValues,
    ...fontSizesPixels,
    ...fontWeights
  }).forEach(([name, value]) => {
    body?.style.setProperty(`--${name}`, value as string);
  });
};

window.addEventListener("turbo:load", setRootCSSVariables);
